import transaction from '@apis/transaction'
import { outlinewallet } from '@assets/icons'
import Analytic from '@commons/cards/analytic'
import Column from '@components/column'
import Grid from '@components/grid'
import Status from '@components/status'
import Table from '@components/table'
import Tab from '@components/tabs'
import Title from '@components/title'
import { RootState } from '@store/index'
import React, { Fragment, useState } from 'react'
import { useSelector } from 'react-redux'
import WalletList from './load-wallet-list'
import PointTransferList from './point-transfer-list'

const LoadWallet = () => {
  const items = [
    {
      label: 'Load Wallet List',
      component: WalletList,
    },
    {
      label: 'Points Transfer Request',
      component: PointTransferList,
    },
  ]
  return (
    <Fragment>
      <Column>
        {/* <Grid>
          {Array.from({ length: 4 }).map((_, i) => (
            <Analytic key={i} />
          ))}
        </Grid> */}
        <Title textone="Payment >" texttwo="Load Wallet" />
        <Tab items={items} />
      </Column>
    </Fragment>
  )
}

export default LoadWallet
